window.createOutProductionProcessMovement = function(production_process_id){
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_movements',
    type: 'POST',
    data:{
      production_process_movement: {
          movement_type: 'out'
      }
    }
  }).done(function(e) {});
}

window.updateOutProductionProcessMovement = function(production_process_id, production_process_movement_id){
  let product_id = $('#production-process-input-elaboration-output-product-id-'+production_process_movement_id).val();
  let code = $('#production-process-input-elaboration-output-code-'+production_process_movement_id).val();  

  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_movements/'+production_process_movement_id,
    type: 'PATCH',
    data:{
      production_process_input: {
          product_id: product_id,
          code: code
      }
    }
  }).done(function(e) {});
}

window.removeOutProductionProcessMovement = function(production_process_id, production_process_movement_id){
  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_movements/'+production_process_movement_id,
    type: 'DELETE'
  }).done(function(e) {});

}